var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 296,
    height: 296,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 80,
    stroke: "black",
    strokeWidth: 3,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M0 0L0 296L296 296L296 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M136 27L136 28L139 28L136 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M139 27L139 28L144 28L139 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M144 27L144 28L150 28L144 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M150 27L150 28L156 28L150 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M156 27L156 28L159 28L156 27M128.667 28.3333L129.333 28.6667L128.667 28.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M130 28L131 29L130 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M131.667 28.3333L132.333 28.6667L131.667 28.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c8791",
      stroke: "none"
    },
    d: "M133 28.4252C114.987 30.8771 97.349 36.3797 82 46.3449C67.4188 55.8116 55.1542 67.473 45.5162 82C14.3592 128.962 20.5471 196.296 61.0147 235.961C88.5292 262.929 127.114 274.821 165 269.718C181.551 267.488 197.843 261.639 212 252.771C286.196 206.293 287.668 92.0596 212 46.0031C200.531 39.0226 188.19 33.5782 175 30.804C161.51 27.9667 146.743 26.5544 133 28.4252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M161.667 28.3333L162.333 28.6667L161.667 28.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M163.667 28.3333L164.333 28.6667L163.667 28.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M165.667 28.3333L166.333 28.6667L165.667 28.3333M122 29L123 30L122 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M123.667 29.3333L124.333 29.6667L123.667 29.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M125 29L126 30L125 29M168.667 29.3333L169.333 29.6667L168.667 29.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M170 29L171 30L170 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M171 29L172 30L171 29M118 30L119 31L118 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M119 30L120 31L119 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M120 30L121 31L120 30M173.667 30.3333L174.333 30.6667L173.667 30.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M175 30L176 31L175 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M176 30L177 31L176 30M114 31L115 32L114 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M115 31L116 32L115 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M116 31L117 32L116 31M178 31L179 32L178 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M179 31L180 32L179 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M180 31L181 32L180 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M111 32L112 33L111 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M112 32L113 33L112 32M181 32L182 33L181 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M182 32L183 33L182 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M183 32L184 33L183 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M108 33L109 34L108 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M109 33L110 34L109 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M185 33L186 34L185 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M186 33L187 34L186 33M105 34L106 35L105 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M106 34L107 35L106 34M188 34L189 35L188 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M189 34L190 35L189 34M102 35L103 36L102 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M103 35L104 36L103 35M190 35L191 36L190 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M191 35L192 36L191 35M100 36L101 37L100 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M101 36L102 37L101 36M193 36L194 37L193 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M194 36L195 37L194 36M97 37L98 38L97 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M98 37L99 38L98 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M195 37L196 38L195 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M196 37L197 38L196 37M95 38L96 39L95 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M96 38L97 39L96 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M198 38L199 39L198 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M93 39L94 40L93 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M94 39L95 40L94 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M200 39L201 40L200 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M91 40L92 41L91 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M92 40L93 41L92 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M202 40L203 41L202 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M89 41L90 42L89 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M90 41L91 42L90 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M204 41L205 42L204 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M88 42L89 43L88 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M206 42L207 43L206 42M86 43L87 44L86 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M207 43L208 44L207 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M208 43L209 44L208 43M84 44L85 45L84 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M209 44L210 45L209 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M82 45L83 46L82 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M83 45L84 46L83 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M211 45L212 46L211 45M81 46L82 47L81 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M212 46L213 47L212 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M213 46L214 47L213 46M79 47L80 48L79 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M80 47L81 48L80 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M214 47L215 48L214 47M78 48L79 49L78 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M216 48L217 49L216 48M76 49L77 50L76 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M77 49L78 50L77 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M217 49L218 50L217 49M75 50L76 51L75 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M218 50L219 51L218 50M74 51L75 52L74 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M220 51L221 52L220 51M72 52L73 53L72 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M221 52L222 53L221 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M71 53L72 54L71 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M222 53L223 54L222 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M70 54L71 55L70 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M224 54L225 55L224 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M69 55L70 56L69 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M225 55L226 56L225 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M226 56L227 57L226 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M66 57L67 58L66 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M227 57L228 58L227 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M65 58L66 59L65 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M228 58L229 59L228 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M64 59L65 60L64 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M229 59L230 60L229 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M63 60L64 61L63 60M62 61L63 62L62 61M61 62L62 63L61 62M60 63L61 64L60 63M59 64L60 65L59 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M134 64L133 67L134 67L134 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M141 64L142 65L141 64M58 65L59 66L58 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M134 65L135 74L136 74L134 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M140 65L140 74L141 74L140 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M141 65L141 74L142 74L141 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M57 66L58 67L57 66M56 67L57 68L56 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M132.333 67.6667L132.667 68.3333L132.333 67.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M133.333 67.6667L133.667 68.3333L133.333 67.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M135 67L137 69L137 67L135 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M137.333 67.6667L137.667 68.3333L137.333 67.6667M142 67L143 68L142 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M143 67L144 68L143 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M143 68L143 69L147 69L143 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M146 67L147 68L146 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M147 67L148 68L147 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M154 67L155 68L154 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M155 74C153.667 68.9793 156.974 69.0771 161 70C156.496 66.1855 149.171 69.7951 155 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M158 67L159 68L158 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M237 67L238 68L237 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M55 68L56 69L55 68M135 68L136 69L135 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M147 68L148 74L149 74L147 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M148 68L149 69L148 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M152 68L153 69L152 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M153 68L154 69L153 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M156 68L157 69L156 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M159 68L160 69L159 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M160 68L161 69L160 68M238 68L239 69L238 68M133 69L133 73L134 73L133 69M142 69L143 70L142 69M147 69L148 70L147 69M149 69L149 74L150 74L149 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c8791",
      stroke: "none"
    },
    d: "M154 71L159 70L154 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M239 69L240 70L239 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M156.667 70.3333L157.333 70.6667L156.667 70.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M158 70L159 71L158 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M159 70L160 71L159 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M160 70L161 71L160 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M240 70L241 71L240 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M53 71L54 72L53 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M153 71L153 72L156 72L153 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M156 71L156 72L159 72L156 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M159 71L160 72L159 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M241 71L242 72L241 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M52 72L53 73L52 72M51 73L52 74L51 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M134 73L135 74L134 73M136 73L137 74L136 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M137 73L136 75L138 75L137 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M152 73L153 74L152 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M153 73L154 74L153 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M155 73L155 75L158 75L158 73L155 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M158.667 73.3333L159.333 73.6667L158.667 73.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M160 73L161 74L160 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M50 74L51 75L50 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M135 74L136 75L135 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M141 74L142 75L141 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M148 74L149 75L148 74M154 74L155 75L154 74M158 74L159 75L158 74M243 74L244 75L243 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M244 75L245 76L244 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M49 76L50 77L49 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M245 76L246 77L245 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M48 77L49 78L48 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M47 78L48 79L47 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M246 78L247 79L246 78M47 79L48 80L47 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M247 79L248 80L247 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M46 80L47 81L46 80M87 80L87 81L115 81L87 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M179 80L180 81L179 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M180 80L180 81L207 81L180 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M207 80L208 81L207 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M45 81L46 82L45 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M248 81L249 82L248 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M249 82L250 83L249 82M44 83L45 84L44 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M43 84L44 85L43 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M87 84L88 85L87 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M88 84L88 85L114 85L88 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M114 84L115 85L114 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M179 84L180 85L179 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M180 84L180 85L207 85L180 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M207 84L208 85L207 84M250 84L251 85L250 84M43 85L44 86L43 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M251 85L252 86L251 85M42 86L43 87L42 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M87 87L87 88L115 88L87 87M179 88L179 89C187.677 86.9341 199.323 86.9341 208 89C202.248 84.642 185.765 86.0004 179 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M252 87L253 88L252 87M41 88L42 89L41 88M87 88L88 89L87 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M88 88L88 89L114 89L88 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M114 88L115 89L114 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M180 88L180 89L207 89L180 88M40 89L41 90L40 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M253 89L254 90L253 89M40 90L41 91L40 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M254 90L255 91L254 90M39 91L40 92L39 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M87 91L88 92L87 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M87 92L87 93L115 93C109.357 88.7245 93.6279 90.0409 87 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M114 91L115 92L114 91M179.333 91.6667L179.667 92.3333L179.333 91.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M180 91L180 93L207 93L207 91L180 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M207.333 91.6667L207.667 92.3333L207.333 91.6667M254 91L255 92L254 91M39 92L40 93L39 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M255 92L256 93L255 92M38 93L39 94L38 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M255 93L256 94L255 93M38 94L39 95L38 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M256 94L257 95L256 94M37 95L38 96L37 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M87 95L87 96L115 96L87 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M179 95C182.404 98.8955 204.596 98.8955 208 95C199.323 97.0659 187.677 97.0659 179 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M180 95L180 96L207 96L180 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M256 95L257 96L256 95M37 96L38 97L37 96M87 96L87 97L115 97L87 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M257 96L258 97L257 96M36 97L37 98L36 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M257 97L258 98L257 97M36 98L37 99L36 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M258 98L259 99L258 98M35 99L36 100L35 99M87 99L87 100L115 100L87 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M179 99L179 100L207 101L207 100L179 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M180 99L180 100L207 100L180 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M207 99L208 100L207 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M258 99L259 100L258 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M35 100L36 101L35 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M87 100L87 101L115 101L87 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M259 100L260 101L259 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M259 101L260 102L259 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M34 102L35 103L34 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M87 103L88 104L87 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M88 103L88 104L114 104L88 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M114 103L115 104L114 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M115 103L116 104L115 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M179 103L180 104L179 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M180 103L180 104L207 104L180 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M207 103L208 104L207 103M260 103L261 104L260 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M33 104L34 105L33 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M260 104L261 105L260 104M33 105L34 106L33 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M261 105L262 106L261 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M86 107L86 108C94.9222 105.876 107.078 105.876 116 108C110.14 103.56 92.901 104.96 86 107M179 106L179 107L208 107L179 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M261 106L262 107L261 106M32 107L33 108L32 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M87 107L87 108L115 108L87 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M179 107L180 108L179 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M180 107L180 108L207 108L180 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M207 107L208 108L207 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M32 108L33 109L32 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M262 108L263 109L262 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M262 109L263 110L262 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M31 110L32 111L31 110M87 110L87 111L115 111L87 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M179 110L180 111L179 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M179 111L179 112C187.677 109.934 199.323 109.934 208 112C202.248 107.642 185.765 109 179 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M207 110L208 111L207 110M31 111L32 112L31 111M86 111L87 112L86 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M87 111L87 112L115 112L87 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M115 111L116 112L115 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M180 111L180 112L207 112L180 111M263 111L264 112L263 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M263 112L264 113L263 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M30 113L31 114L30 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M30 114L31 115L30 114M86.3333 114.667L86.6667 115.333L86.3333 114.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M87 114L87 116L115 116L115 114L87 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M115.333 114.667L115.667 115.333L115.333 114.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M179.333 114.667L179.667 115.333L179.333 114.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M180 114L180 116L207 116L207 114L180 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M207.333 114.667L207.667 115.333L207.333 114.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M264 114L265 115L264 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M264 115L265 116L264 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M29 116L30 117L29 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M264 116L265 117L264 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M29 117L30 118L29 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M29 118L30 119L29 118M86 118L87 119L86 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 118L87 119L115 119L87 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M115 118L116 119L115 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M179 118L180 119L179 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M180 118L180 119L207 119L180 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M207 118L208 119L207 118M265 118L266 119L265 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M87 119L87 120L115 120L87 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M179 119L180 120L179 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M180 119L180 120L207 120L180 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M207 119L208 120L207 119M265 119L266 120L265 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M28 120L29 121L28 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M28.3333 121.667L28.6667 122.333L28.3333 121.667M86 122L86 123C94.1286 125.403 107.871 125.403 116 123L116 122C107.078 124.124 94.9222 124.124 86 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 122L87 123L115 123L87 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M179 122L180 123L179 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M180 122L180 123L207 123L180 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M207 122L208 123L207 122M266 122L267 123L266 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M179 123L179 124L208 124L179 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M266 123L267 124L266 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M27 124L28 125L27 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M266 124L267 125L266 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M27 125L28 126L27 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M86 126L86 127L120 128L120 127L87 127L87 126L121 126C112.971 122.631 94.3132 123.543 86 126M173 126L173 127L207 128L207 127L174 127L174 126L208 126C199.971 122.631 181.313 123.543 173 126M27.3333 126.667L27.6667 127.333L27.3333 126.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 126L87 127L120 127L87 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M120 126L121 127L120 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M174 126L174 127L208 127L174 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M267.333 126.667L267.667 127.333L267.333 126.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M267 128L268 129L267 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M26.3333 129.667L26.6667 130.333L26.3333 129.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M86.3333 129.667L86.6667 130.333L86.3333 129.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M87 129L88 130L87 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M88 129L88 130L125 130C115.202 125.889 98.6488 129 88 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M125 129L126 130L125 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M169 129L170 130L169 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M170 129L170 130L207 130C197.202 125.889 180.649 129 170 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M207 129L208 130L207 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M267.333 129.667L267.667 130.333L267.333 129.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 130L87 131L125 131C114.964 126.789 97.9106 130 87 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M125 130L126 131L125 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M169 130L169 131L208 131C197.726 126.689 180.172 130 169 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M26.3333 131.667L26.6667 132.333L26.3333 131.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M268 132L268 135L269 135L268 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M26.3333 133.667L26.6667 134.333L26.3333 133.667M86.3333 133.667L86.6667 134.333L86.3333 133.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M87 133L87 134L132 135L120 133L87 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M162.333 133.667L162.667 134.333L162.333 133.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M163 133L163 134L208 135L196 133L163 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 134L87 135L131 135C119.537 130.19 99.4804 134 87 134M163 134L163 135L207 135C195.537 130.19 175.48 134 163 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M268.333 135.667L268.667 136.333L268.333 135.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M25 137L25 140L26 140L25 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M86 137L87 138L86 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 137L87 138L137 138C124.11 132.591 101.049 137 87 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M137 137L138 138L137 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M157 137L157 138C171.985 142.429 192.361 139 208 139L208 138L157 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M158 137L158 138L208 138C195.11 132.591 172.049 137 158 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M268.333 137.667L268.667 138.333L268.333 137.667M86 138L87 139L86 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M87 138L87 139L137 139C124.11 133.591 101.049 138 87 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M157 138L158 139L157 138M25 140L25 144L26 144L25 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M87 140L87 141L143 141L125 140L87 140M152 140L152 141L208 141L190 140L152 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M86 141L86 142C102.654 146.923 125.609 143 143 143L143 142C124.994 142 103.527 145.173 86 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 141L87 142L143 142L125 141L87 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M151 141L151 142C167.654 146.923 190.609 143 208 143L208 142C189.994 142 168.527 145.173 151 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M152 141L152 142L208 142L190 141L152 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M86 142L87 143L86 142M151 142L152 143L151 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M269 143L269 155L270 155L269 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M25 144L25 154L26 154L25 144M87 144L87 145L206 145L170 144L87 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M206 144L207 145L206 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M207 144L207 147L208 147L207 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M86 145L86 146L126 147L207 147L207 146L127 146L86 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 145L87 146L208 146C198.211 141.892 181.634 145 171 145L87 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M86 146L87 147L86 146M86 148L87 149L86 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M86 149L86 150L128 149L208 149L174 148L116 148L86 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 149L87 150L208 150C198.211 145.892 181.634 149 171 149L87 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M87 150L87 151L208 151C198.211 146.892 181.634 150 171 150L87 150M86 152L87 153L86 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M87 152L87 153L208 153C198.211 148.892 181.634 152 171 152L87 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M86 153L87 154L86 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 153L87 154L208 154C198.211 149.892 181.634 153 171 153L87 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M25 154L25 158L26 158L25 154M86 156L87 157L86 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 156L87 158L142 158L142 156L87 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M142.333 156.667L142.667 157.333L142.333 156.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M151.333 156.667L151.667 157.333L151.333 156.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M152 156L152 158L207 158L207 156L152 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M207.333 156.667L207.667 157.333L207.333 156.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M86 157L87 158L86 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M25 158L25 162L26 162L25 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M268 159L268 162L269 162L268 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M86 160L87 161L86 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 160L87 161L137 161C124.11 155.591 101.049 160 87 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M137 160L138 161L137 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M157 160L157 161C171.707 165.347 191.652 162 207 162L207 161L157 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M158 160L158 161L208 161C195.11 155.591 172.049 160 158 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M86 161L87 162L86 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M87 161L87 162L137 162C124.11 156.591 101.049 161 87 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M157 161L158 162L157 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M207 161L208 162L207 161M268.333 162.667L268.667 163.333L268.333 162.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M87 163L87 164L132 164C120.299 159.09 99.742 163 87 163M163 163L163 164L208 164C196.299 159.09 175.742 163 163 163M26.3333 164.667L26.6667 165.333L26.3333 164.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M86 164L86 165L131 166L131 165L86 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 164L87 165L132 165C120.299 160.09 99.742 164 87 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M162 164L162 165L207 166L207 165L162 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M163 164L163 165L208 165C196.299 160.09 175.742 164 163 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M268.333 164.667L268.667 165.333L268.333 164.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M131 165L132 166L131 165M162 165L163 166L162 165M207 165L208 166L207 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M26 166L27 167L26 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M26.3333 167.667L26.6667 168.333L26.3333 167.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M87 167L87 168L126 168C115.726 163.689 98.1724 167 87 167M169 167L169 168L208 168C197.726 163.689 180.172 167 169 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M86 168L87 169L86 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 168L87 169L125 169C114.964 164.789 97.9106 168 87 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M125 168L126 169L125 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M169 168L169 169L208 169C197.726 164.689 180.172 168 169 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M267.333 168.667L267.667 169.333L267.333 168.667M87 169L87 170L125 170C114.964 165.789 97.9106 169 87 169M169 169L169 170L208 170C197.726 165.689 180.172 169 169 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M267 170L268 171L267 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M27 171L28 172L27 171M86.3333 171.667L86.6667 172.333L86.3333 171.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M87 171L87 172L120 172L87 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M120 171L121 172L120 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M174 171L174 172L208 172L174 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M267 171L268 172L267 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M27 172L28 173L27 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 172L87 173L120 173L87 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M120 172L121 173L120 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M173 172L174 173L173 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M174 172L174 173L207 173L174 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M207 172L208 173L207 172M27.3333 173.667L27.6667 174.333L27.3333 173.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M266 174L267 175L266 174M86.3333 175.667L86.6667 176.333L86.3333 175.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M87 175L87 177L115 177L115 175L87 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M115.333 175.667L115.667 176.333L115.333 175.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M179.333 175.667L179.667 176.333L179.333 175.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M180 175L180 177L208 177C201.782 172.289 187.649 175 180 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M207 175L208 176L207 175M266 175L267 176L266 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M28 176L29 177L28 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M266 176L267 177L266 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M28 177L29 178L28 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M28 178L29 179L28 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M265 178L266 179L265 178M86 179L87 180L86 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M87 179L87 180L115 180L87 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M115.333 179.667L115.667 180.333L115.333 179.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M179 179L179 180L208 180L179 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M265 179L266 180L265 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M29 180L30 181L29 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M87 180L88 181L87 180M89 180L89 181L113 181L89 180M114 180L115 181L114 180M179 180L180 181L179 180M181 180L181 181L206 181L181 180M207 180L208 181L207 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M265 180L266 181L265 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M29 181L30 182L29 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M29 182L30 183L29 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M264 182L265 183L264 182M86 183L86 184C94.1285 186.403 107.871 186.403 116 184L116 183C107.078 185.124 94.9222 185.124 86 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 183L87 184L115 184L87 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M179 183L180 184L179 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M180 183L180 184L207 184L180 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M207 183L208 184L207 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M264 183L265 184L264 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M30 184L31 185L30 184M179 184L179 185L208 185L179 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M264 184L265 185L264 184M30 185L31 186L30 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M263 185L264 186L263 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M263 186L264 187L263 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M31 187L32 188L31 187M86 187L86 188C94.1285 190.403 107.871 190.403 116 188L116 187C107.078 189.124 94.9222 189.124 86 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 187L87 188L115 188L87 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M179 187L180 188L179 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M180 187L180 188L207 188L180 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M207 187L208 188L207 187M263 187L264 188L263 187M31 188L32 189L31 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M180 188L180 189L207 189L180 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M262 189L263 190L262 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M32 190L33 191L32 190M86 191L86 192C94.9222 189.876 107.078 189.876 116 192C110.14 187.56 92.901 188.96 86 191M179 190L179 191L208 191L179 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M262 190L263 191L262 190M32 191L33 192L32 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M87 191L87 192L115 192L87 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M179 191L180 192L179 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M180 191L180 192L207 192L180 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M207 191L208 192L207 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M261 191L262 192L261 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M261 192L262 193L261 192M33 193L34 194L33 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M33 194L34 195L33 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M87 194L88 195L87 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M88 194L89 195L88 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M89 194L89 195L116 196C109.935 191.405 96.4503 194 89 194M179 194L180 195L179 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M180 194L179 196L180 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M181 194L181 195L206 195L181 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M206 194L208 196L206 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M207 194L208 195L207 194M260 194L261 195L260 194M34 195L35 196L34 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M87 195L87 196L115 196L87 195M180 195L180 196L207 196L180 195M260 195L261 196L260 195M34 196L35 197L34 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M259 197L260 198L259 197M35 198L36 199L35 198M87 198L87 200L115 200L115 198L87 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M179.333 198.667L179.667 199.333L179.333 198.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M180 198L180 200L207 200L207 198L180 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M207.333 198.667L207.667 199.333L207.333 198.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M258 199L259 200L258 199M36 200L37 201L36 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M257 201L258 202L257 201M37 202L38 203L37 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M87 202L88 203L87 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M88 202L88 203L115 203L88 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M179 202L179 203C186.918 205.34 200.082 205.34 208 203L208 202C199.323 204.066 187.677 204.066 179 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M180 202L180 203L207 203L180 202M257 202L258 203L257 202M37 203L38 204L37 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M87 203L87 204L115 204L87 203M256 203L257 204L256 203M38 204L39 205L38 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M256 204L257 205L256 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M255 205L256 206L255 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M39 206L40 207L39 206M87 206L88 207L87 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M88 206L88 207L115 207L88 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M179 206L180 207L179 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M180 206L180 207L207 207L180 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M207 206L208 207L207 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M255 206L256 207L255 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M254 207L255 208L254 207M40 208L41 209L40 208M253 209L254 210L253 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M41 210L42 211L41 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M87 210L88 211L87 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M88 210L88 211L114 211L88 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M114 210L115 211L114 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M179 210L180 211L179 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M180 210L180 211L207 211L180 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M207 210L208 211L207 210M42 211L43 212L42 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M252 211L253 212L252 211M42 212L43 213L42 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M251 212L252 213L251 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M43 213L44 214L43 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M87 213L87 214L115 214L87 213M179 214L179 215C187.677 212.934 199.323 212.934 208 215C202.248 210.642 185.765 212 179 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M87 214L87 215L115 215L87 214M180 214L180 215L207 215L180 214M250 214L251 215L250 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M44 215L45 216L44 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M249 215L250 216L249 215M45 216L46 217L45 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M249 216L250 217L249 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M87 217L87 219L115 219L115 217L87 217M179 218L179 219L208 219C202.248 214.642 185.765 216 179 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M248 217L249 218L248 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M46 218L47 219L46 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M247 218L248 219L247 218M47 219L48 220L47 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M247 219L248 220L247 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M246 220L247 221L246 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M48 221L49 222L48 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M245 221L246 222L245 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M49 222L50 223L49 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M50 223L51 224L50 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M244 223L245 224L244 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M150.333 224.667L150.667 225.333L150.333 224.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M151.333 224.667L151.667 225.333L151.333 224.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M243 224L244 225L243 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M242 225L243 226L242 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M52 226L53 227L52 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M241 226L242 227L241 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M53 227L54 228L53 227M94 227L96 229L94 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M95 227L95 228L99 229L95 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M99 227L100 228L99 227M104 227L105 228L104 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M105 227L105 230L106 230L105 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M111 227L112 228L111 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M112 227L111 230L112 230L112 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M116 227L117 228L116 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M117 227L116 237L117 237L117 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M118 227L118 228L123 232L124 232L118 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M119 227L119 228L123 228L119 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M123 227L124 228L123 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M130 227L131 228L130 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M131 229L135 229C133.444 227.187 132.556 227.187 131 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M135 227L136 228L135 227M140 227L141 235L142 235L140 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M141 227L142 228L141 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M142 227L143 228L142 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M143 227L143 228L147 229L143 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M150 227L151 228L150 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M151 227L150 234L151 234L151 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M156 227L157 228L156 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M157 229L162 229L157 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M161 227L162 228L161 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M162 227L164 229L162 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M167 227L167 228L168 234L169 234L167 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M169 227L169 228C172.492 229.057 173.432 230.418 174 234L176 234C175.655 229.1 173.9 227.345 169 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M174 227L176 229L174 227M180 227L181 228L180 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M181.333 227.667L181.667 228.333L181.333 227.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M182 227L182 228L186 228L182 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M186 227L187 228L186 227M192 227L191 229L192 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M193 227L195 229L193 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M194 227L194 228L198 229L198 230L193 231C197.514 232.442 199.317 227.931 194 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M198 227L199 228L198 227M54 228L55 229L54 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M93 228L93 233L94 233L93 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M94 228L95 229L94 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M96 228L97 229L96 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M97 228L98 229L97 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M99 228L99 231L100 231L99 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M100 228L101 229L100 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M105 228L107 232L111 230L111 229L105 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M106 228L107 229L106 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M112 228L113 229L112 228M117.333 228.667L117.667 229.333L117.333 228.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M118 228L119 229L118 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M123 228L124 233L118 231L117 231C118.246 236.814 128.208 233.242 123 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M124 228L125 229L124 228M129 228L130 229L129 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M130 228L129 233L132 232L130 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M132.667 228.333L133.333 228.667L132.667 228.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M135 228L137 230L135 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M136 228L137 229L136 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M141 228L141 234L142 234L143 228L141 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M143 228L144 229L143 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M144.667 228.333L145.333 228.667L144.667 228.333M147 228L148 229L147 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M151 228L151 234L152 234L151 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M155 228L157 230L155 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M156 228L157 229L156 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M158 228L159 229L158 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M159 228L160 229L159 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M160 228L161 229L160 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M162 228L162 231L163 231L162 228M167 228L167 234L168 234L169 228L167 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M170 228L170 229L173 229L170 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M174 228L175 229L174 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M179 228L180 229L179 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M180 228L181 229L180 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M182 228L182 229L185 229L182 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M185 228L186 229L185 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M186 228L187 229L186 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M187 228L188 229L187 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M192 228L193 229L192 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M193 228L191 229L191 230L193 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M195 228L196 229L195 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M196 228L197 229L196 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M198 228L198 231L199 231L198 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M199 228L200 229L199 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M240 228L241 229L240 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M55 229L56 230L55 229M92 229L92 233L93 233L92 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c8791",
      stroke: "none"
    },
    d: "M94 229L94 230L99 230L94 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M99 229L100 230L99 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M107 229L108 230L107 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M109 229L110 230L109 229M112 229L113 230L112 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c8791",
      stroke: "none"
    },
    d: "M118 229L123 233L123 229L118 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M128 229L128 233L129 233L128 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c8791",
      stroke: "none"
    },
    d: "M130 229L130 230L135 230L130 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M135 229L136 230L135 229M137 229L138 230L137 229M142 229L143 230L142 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M155 229L156 230L155 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c8791",
      stroke: "none"
    },
    d: "M157 229L157 230L162 230L157 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M163 229L164 230L163 229M179 229C179.728 233.362 181.824 233.863 186 234L186 233L180 232L181 229L179 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M187 229L188 230L187 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c8791",
      stroke: "none"
    },
    d: "M193 229L193 230L198 230L193 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M239 229L240 230L239 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M94 230L94 231L98 231L94 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M98 230L99 231L98 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M100 230L101 231L100 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M110 230L111 231L110 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M117 230L118 231L117 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M130 230L130 231L134 231L130 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M134 230L135 231L134 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M132 231L132 232L137 231L132 231M155 230C156.343 234.046 159.065 233.953 163 234L163 233L157 233L157 232L162 231L155 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M157 230L157 231L160 231L157 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M160 230L161 231L160 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M163 230L164 231L163 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M191 230L191 233L192 233L191 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M192 230L192 233L193 233L192 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M193 230L193 231L197 231L193 230M199 230L200 231L199 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M238 230L239 231L238 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M94 231L94 232L99 232L94 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M99 231L101 233L99 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M106 231L107 232L106 231M108 231L109 232L108 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M109.667 231.333L110.333 231.667L109.667 231.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M111 231L112 232L111 231M135 231L137 233L135 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M156 231L157 232L156 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M161 231L162 232L161 231M180 231L181 232L180 231M197 231L198 232L197 231M237 231L238 232L237 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M94 232L95 233L94 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c8791",
      stroke: "none"
    },
    d: "M95 232L95 233L100 233L95 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M104 232L105 233L104 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M105.333 232.667L105.667 233.333L105.333 232.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M106 232L107 233L106 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M107 232L108 233L107 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M110 232L110 233L113 233L113 232L110 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M111 232L112 233L111 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M118 232L119 233L118 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M123 232L124 233L123 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M130 232L131 233L130 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c8791",
      stroke: "none"
    },
    d: "M131 232L131 233L136 233L131 232M157 232L157 233L162 233L157 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M162 232L163 233L162 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M186.667 232.333L187.333 232.667L186.667 232.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c8791",
      stroke: "none"
    },
    d: "M193 232L193 233L198 233L193 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M198 232L200 234L200 232L198 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M236 232L237 233L236 232M93 233L94 234L93 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M94 233L94 234L100 234L94 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M100 233L101 234L100 233M104 233L105 234L104 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M112 233L113 234L112 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M124 233L125 234L124 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M129 233L130 234L129 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M130.667 233.333L131.333 233.667L130.667 233.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M132 233L132 235L134 235L134 233L132 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M134 233L134 234L137 234L134 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M155 233L156 234L155 233M163 233L164 234L163 233M179 233L180 234L179 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M186 233L187 234L186 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M187 233L188 234L187 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M192 233L192 234L199 234L192 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M235 233L236 234L235 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M59 234L60 235L59 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M95 234L96 235L95 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M96.6667 234.333L97.3333 234.667L96.6667 234.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M98 234L99 235L98 234M104.667 234.333L105.333 234.667L104.667 234.333M112 234L113 235L112 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M117 234L118 235L117 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M119 234L119 235L123 235L119 234M130.667 234.333L131.333 234.667L130.667 234.333M134.667 234.333L135.333 234.667L134.667 234.333M151 234L152 235L151 234M157.667 234.333L158.333 234.667L157.667 234.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M159 234L160 235L159 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M160.667 234.333L161.333 234.667L160.667 234.333M167 234L168 235L167 234M174.667 234.333L175.333 234.667L174.667 234.333M181.667 234.333L182.333 234.667L181.667 234.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M183 234L184 235L183 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M184.667 234.333L185.333 234.667L184.667 234.333M193.667 234.333L194.333 234.667L193.667 234.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M195 234L196 235L195 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M196.667 234.333L197.333 234.667L196.667 234.333M234 234L235 235L234 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M60 235L61 236L60 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M117.333 235.667L117.667 236.333L117.333 235.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M233 235L234 236L233 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M61 236L62 237L61 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M232 236L233 237L232 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M62 237L63 238L62 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M117 237L118 238L117 237M231 237L232 238L231 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M230 238L231 239L230 238M229 239L230 240L229 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M66 240L67 241L66 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M228 240L229 241L228 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M67 241L68 242L67 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M227 241L228 242L227 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M68 242L69 243L68 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M226 242L227 243L226 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M69 243L70 244L69 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M224 243L225 244L224 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M70 244L71 245L70 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M223 244L224 245L223 244M72 245L73 246L72 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M222 245L223 246L222 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M73 246L74 247L73 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M221 246L222 247L221 246M74 247L75 248L74 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M219 247L220 248L219 247M76 248L77 249L76 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M218 248L219 249L218 248M77 249L78 250L77 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M216 249L217 250L216 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M217 249L218 250L217 249M78 250L79 251L78 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M79 250L80 251L79 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M215 250L216 251L215 250M80 251L81 252L80 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M214 251L215 252L214 251M81 252L82 253L81 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M82 252L83 253L82 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M212 252L213 253L212 252M83 253L84 254L83 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M210 253L211 254L210 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M211 253L212 254L211 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M85 254L86 255L85 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M209 254L210 255L209 254M86 255L87 256L86 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M87 255L88 256L87 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M207 255L208 256L207 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M88 256L89 257L88 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M205 256L206 257L205 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M90 257L91 258L90 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M203 257L204 258L203 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M204 257L205 258L204 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M92 258L93 259L92 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M201 258L202 259L201 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M202 258L203 259L202 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M94 259L95 260L94 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M199 259L200 260L199 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M200 259L201 260L200 259M96 260L97 261L96 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M97 260L98 261L97 260M197 260L198 261L197 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M198 260L199 261L198 260M98 261L99 262L98 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M99 261L100 262L99 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M195 261L196 262L195 261M101 262L102 263L101 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M192 262L193 263L192 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M193 262L194 263L193 262M103 263L104 264L103 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M104 263L105 264L104 263M189 263L190 264L189 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M190 263L191 264L190 263M106 264L107 265L106 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M107 264L108 265L107 264M187 264L188 265L187 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M188 264L189 265L188 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M109 265L110 266L109 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M110 265L111 266L110 265M184 265L185 266L184 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M185 265L186 266L185 265M112 266L113 267L112 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M113 266L114 267L113 266M180 266L181 267L180 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M181 266L182 267L181 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M182 266L183 267L182 266M115 267L116 268L115 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M116 267L117 268L116 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M117 267L118 268L117 267M176.667 267.333L177.333 267.667L176.667 267.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M178 267L179 268L178 267M119 268L120 269L119 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M120 268L121 269L120 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M121.667 268.333L122.333 268.667L121.667 268.333M172 268L173 269L172 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M173 268L174 269L173 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M174 268L175 269L174 268M124 269L125 270L124 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M125 269L126 270L125 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M126.667 269.333L127.333 269.667L126.667 269.333M166.667 269.333L167.333 269.667L166.667 269.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M168 269L169 270L168 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M169.667 269.333L170.333 269.667L169.667 269.333M130.667 270.333L131.333 270.667L130.667 270.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M132.667 270.333L133.333 270.667L132.667 270.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7da7ae",
      stroke: "none"
    },
    d: "M134 270L134 271L137 271L134 270M158 270L158 271L161 271L158 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6c2c7",
      stroke: "none"
    },
    d: "M161 270L162 271L161 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdd2d5",
      stroke: "none"
    },
    d: "M162 270L162 271L165 271L162 270M140 271L140 272L154 272L140 271z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHh);
export default __webpack_public_path__ + "static/media/HH.0dfd881d5e61ba639bee7492ff14b1e3.svg";
export { ForwardRef as ReactComponent };